import React from "react";
import "./HomeContentView.css";
import iconEaseInLife from '../../assets/svg/ic_ease_in_life.svg';
import iconSimpleHuman from '../../assets/svg/ic_simple_human.svg';
import iconWithLove from '../../assets/svg/ic_with_love.svg';

const HomeContentView = () => {
    return (
        <div class="content-container">
            <div class="card">
                <h1>Simply,<br />in a human way</h1>
                <p>Our main principle in creating applications is simplicity, we are also tired of all these complicated terms and all-in-one programs.</p>
                <div class="icon"><img src={iconEaseInLife} alt="Simply, in a human way" /></div>
            </div>
            <div class="card">
                <h1>With ease<br />in life</h1>
                <p>Who said that success and a happy life have to be a boring existence in the middle of planners and piles of papers?</p>
                <div class="icon"><img src={iconSimpleHuman} alt="With ease in life" /></div>
            </div>
            <div class="card">
                <h1>With love<br />to every user</h1>
                <p>We want and love to do everything from people and for people &lt;3</p>
                <div class="icon"><img src={iconWithLove} alt="With love to every user" /></div>
            </div>
        </div>
    );
}

export default HomeContentView;